import React from "react";
import { Card, CardBody } from "reactstrap";
import { Link } from "react-router-dom";
import calculateAvgRating from "../utils/avgRating";
import { BASE_URL } from "../utils/config";
import { findTourSeoById } from "../assets/data/toursSeo";
import "./tour-card.css";

const TourCard = ({ tour }) => {
  const { id, title, city, photo, price, featured, reviews, pricingType } = tour;
  const imagePath = BASE_URL + photo;
  const { totalRating, avgRating } = calculateAvgRating(reviews);
  const tourUrl = `/tours/${findTourSeoById(id)?.slug || id}`;

  return (
    <div className="tour__card">
      <Card>
        <div className="tour__img">
          <img src={imagePath} alt="tour-img" />
          {featured > 0 && <span>Featured</span>}
        </div>

        <CardBody>
          <div className="card__top d-flex align-items-center justify-content-between">
            <span className="tour__location d-flex align-items-center gap-1">
              <i className="ri-map-pin-line"></i> {city}
            </span>

            <span className="tour__rating d-flex align-items-center gap-1">
              <i className="ri-star-fill"></i>{" "}
              {avgRating === 0 ? null : avgRating}
              {totalRating === 0 ? (
                "Not rated"
              ) : (
                <span>({reviews.length})</span>
              )}
            </span>
          </div>
          <h5 className="tour__title">
            <Link to={tourUrl}>{title}</Link>
          </h5>

          <div className="card__bottom d-flex align-items-center justify-content-between mt-3">
            <h5>
              ${price} <span>/{pricingType}</span>
            </h5>

            <button className="btn booking__btn">
              <Link to={tourUrl}>Reserve Tour</Link>
            </button>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default TourCard;
